import Vue from 'vue'
import Loading from './Loading.vue'

const loading = Vue.prototype.$loading = new Vue(Loading).$mount()
document.body.appendChild(loading.$el)

export default loading